import { ApiHttpClient } from '../../../http/clients/api';
import { TeamDeal, TeamDeals } from 'app/models/dto/team-deal';
import { Injectable } from '@angular/core';
import { AbstractCrudService } from 'app/services/abstract-crud/abstract-crud.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Deal } from 'ng2-app/models/dto/deal.model';

@Injectable()
export class TeamDealsService {
    baseUrl = '/team-deals';

    constructor(
      private http: ApiHttpClient,
    ) {}

  get(teamId: number): Observable<TeamDeal[]> {
    return this.http.get<TeamDeal[]>(`${this.baseUrl}/${teamId}`);
  }
}

@Injectable()
export class LenderUserDealsService {
  baseUrl = '/team-deals/lender-user';

  constructor(
    private http: ApiHttpClient,
  ) {}

  get(lenderUserId: number): Observable<TeamDeal[]> {
    return this.http.get<TeamDeal[]>(`${this.baseUrl}/${lenderUserId}`);
  }
}
